import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DataList from './dataList.jsx'
import { connect } from 'react-redux'
import {
    addFile,
    removeFile,
    getServices,
    getFiles,
} from '../../redux/actions/items.js'

class personalInfo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            notificationText: {
                limitFileSize: false,
                limitCloudStorage: false,
            },
        }
    }

    componentDidMount() {
        this.props.getServices()
        this.props.getFiles()
    }

    render() {
        return (
            <div className="ePassport">
                <div className="ePassport_tabName">
                    <p>ePassport</p>
                    {this.sFileInfo()}
                    {this.cDriveInfo()}
                </div>
                <div className="ePassport_listOfData">
                    <DataList
                        translate={this.props.translate}
                        enableNotification={this.enableNotification}
                    />
                </div>
            </div>
        )
    }

    sFileInfo = () => {
        if (!this.state.notificationText.limitFileSize) return null
        let { translate } = this.props
        let notification =
            translate['The maximum size of the uploaded files is 5 MB']
        this.enableNotificationTimer('limitFileSize')
        return <span>{notification}</span>
    }

    cDriveInfo = () => {
        if (!this.state.notificationText.limitCloudStorage) return null
        let { translate } = this.props
        let notification = translate['Google Drive is full']
        this.enableNotificationTimer('limitCloudStorage')
        return <span>{notification}</span>
    }

    enableNotification = type => {
        if (this.state.notificationText[type] === 'true') return null

        let notificationText = Object.assign({}, this.state.notificationText)

        for (let item in notificationText) {
            if (item === type) {
                notificationText[type] = true
            } else {
                notificationText[item] = false
            }
        }

        this.setState({ notificationText })
    }

    enableNotificationTimer = type => {
        setTimeout(() => {
            if (this.state.notificationText[type] === 'false') return null

            let notificationText = Object.assign(
                {},
                this.state.notificationText
            )

            for (let item in notificationText) {
                if (item === type) {
                    notificationText[type] = false
                }
            }

            this.setState({ notificationText })
        }, 5000)
    }
}

const mapStateToProps = state => {
    return {
        file: state.addFile,
        removeFile: state.removeFile,
        dataCollection: state.AddFiles,
    }
}

const mapDispatchProps = dispatch => {
    return {
        addFile: file => dispatch(addFile(file)),
        removeFile: file => dispatch(removeFile(file)),
        getServices: () => dispatch(getServices()),
        getFiles: address => dispatch(getFiles(address)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchProps
)(personalInfo)
